import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const PerfectProductHeadline = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14911)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#ECFEFF"
          />
          <rect
            x="82.75"
            y="46.75"
            width="94.5"
            height="56.5"
            rx="4.39286"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M171.188 47L84 100.2C84 100.2 84.6124 101.655 85.7024 102.18C86.7925 102.705 88.2709 103 89.8125 103H171.188C172.729 103 174.208 102.705 175.298 102.18C176.388 101.655 177 100.943 177 100.2V49.8C177 49.0574 176.388 48.3452 175.298 47.8201C174.208 47.295 171.188 47 171.188 47Z"
            fill="#E3E3E3"
          />
          <path
            d="M105.674 66.8616H149.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M105.674 74.5758H139.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M105.674 82.2901H149.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M105.674 90.0044H149.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="82.75"
            y="46.75"
            width="94.5"
            height="56.5"
            rx="4.39286"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M60.5961 60.6141L63.0015 63.0195L71.0194 55.0016L68.614 52.5962C67.545 51.5613 66.112 50.9881 64.6241 51.0002C63.1363 51.0123 61.7128 51.6087 60.6607 52.6608C59.6086 53.7129 59.0122 55.1364 59.0001 56.6242C58.988 58.1121 59.5612 59.5451 60.5961 60.6141Z"
            fill="#FF808C"
          />
          <path
            d="M79.7749 79.7928L91 83L87.7928 71.7749L79.7749 79.7928Z"
            fill="#FFBC44"
          />
          <path
            d="M71.0194 55.0048L87.7928 71.7783L79.7749 79.7962L63.0015 63.0227L71.0194 55.0048Z"
            fill="#FFEF5E"
          />
          <path
            d="M60.5961 60.6141L63.0015 63.0195L71.0194 55.0016L68.614 52.5962C67.545 51.5613 66.112 50.9881 64.6241 51.0002C63.1363 51.0123 61.7128 51.6087 60.6607 52.6608C59.6086 53.7129 59.0122 55.1364 59.0001 56.6242C58.988 58.1121 59.5612 59.5451 60.5961 60.6141Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M79.7749 79.7928L91 83L87.7928 71.7749L79.7749 79.7928Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.0194 55.0048L87.7928 71.7783L79.7749 79.7962L63.0015 63.0227L71.0194 55.0048Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117 39C117 38.4477 117.448 38 118 38H190C190.552 38 191 38.4477 191 39V55.7001C191 56.2523 190.552 56.7001 190 56.7001H118C117.448 56.7001 117 56.2523 117 55.7001V39Z"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="2"
          />
          <path
            d="M121.393 44.354V43.3735C121.393 43.1134 121.496 42.864 121.68 42.6801C121.864 42.4962 122.113 42.3929 122.373 42.3929H129.237C129.497 42.3929 129.747 42.4962 129.931 42.6801C130.114 42.864 130.218 43.1134 130.218 43.3735V44.354"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M125.805 42.3928V51.2176"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M123.845 51.2176H127.767"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M132.887 51.7082H141.603"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M182.461 107.234H160.899C160.422 107.234 159.957 107.081 159.572 106.798C159.187 106.515 158.903 106.117 158.761 105.661L156.428 98.1936C156.323 97.8584 156.299 97.5032 156.357 97.1567C156.415 96.8103 156.553 96.4823 156.761 96.1993C156.969 95.9163 157.241 95.6862 157.554 95.5275C157.868 95.3688 158.214 95.286 158.565 95.2858H184.131C184.454 95.2869 184.769 95.182 185.027 94.9871L183.656 107.81C183.52 107.623 183.339 107.472 183.131 107.372C182.922 107.271 182.692 107.224 182.461 107.234Z"
            fill="#C2F3FF"
          />
          <path
            d="M163.725 102.924C163.248 102.923 162.783 102.771 162.399 102.488C162.015 102.206 161.73 101.808 161.588 101.352L159.691 95.2858H158.565C158.214 95.286 157.868 95.3688 157.554 95.5275C157.241 95.6862 156.969 95.9163 156.761 96.1993C156.553 96.4824 156.415 96.8103 156.357 97.1568C156.299 97.5032 156.323 97.8584 156.428 98.1937L158.761 105.661C158.903 106.117 159.187 106.515 159.572 106.798C159.957 107.081 160.422 107.234 160.899 107.234H182.461C182.692 107.224 182.922 107.271 183.131 107.372C183.339 107.473 183.52 107.623 183.656 107.81L184.177 102.924H163.725Z"
            fill="#66E1FF"
          />
          <path
            d="M190.675 89.3118H186.855C186.672 89.3105 186.494 89.3765 186.357 89.4974C186.219 89.6183 186.13 89.7856 186.108 89.9675L185.612 93.976C185.567 94.3374 185.392 94.67 185.119 94.9112C184.846 95.1525 184.495 95.2857 184.131 95.2858H158.565C158.214 95.286 157.868 95.3688 157.554 95.5275C157.241 95.6862 156.969 95.9163 156.761 96.1993C156.553 96.4823 156.415 96.8103 156.357 97.1567C156.299 97.5032 156.323 97.8584 156.428 98.1936L158.761 105.661C158.903 106.117 159.187 106.515 159.572 106.798C159.957 107.081 160.422 107.234 160.899 107.234H182.461C182.857 107.234 183.237 107.391 183.517 107.671C183.797 107.951 183.954 108.331 183.954 108.727C183.954 109.123 183.797 109.503 183.517 109.783C183.237 110.063 182.857 110.221 182.461 110.221H161.552"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M184.703 98.2728L184.043 104.214"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M164.541 117.688C165.135 117.688 165.704 117.452 166.125 117.032C166.545 116.612 166.781 116.042 166.781 115.448C166.781 114.854 166.545 114.284 166.125 113.864C165.704 113.444 165.135 113.208 164.541 113.208C163.946 113.208 163.377 113.444 162.956 113.864C162.536 114.284 162.3 114.854 162.3 115.448C162.3 116.042 162.536 116.612 162.956 117.032C163.377 117.452 163.946 117.688 164.541 117.688Z"
            fill="#D7D7D7"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M180.969 117.688C181.563 117.688 182.133 117.452 182.553 117.032C182.973 116.612 183.209 116.042 183.209 115.448C183.209 114.854 182.973 114.284 182.553 113.864C182.133 113.444 181.563 113.208 180.969 113.208C180.375 113.208 179.805 113.444 179.385 113.864C178.965 114.284 178.729 114.854 178.729 115.448C178.729 116.042 178.965 116.612 179.385 117.032C179.805 117.452 180.375 117.688 180.969 117.688Z"
            fill="#D7D7D7"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14911">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
PerfectProductHeadline.displayName = 'PerfectProductHeadline';
